function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../../_snowpack/pkg/react.js';
import PropTypes from '../../../_snowpack/pkg/prop-types.js';
import styled from '../../../_snowpack/pkg/styled-components.js';
import { sizes, Switch } from '../index.js';
const SwitchWithLabelCmp = styled.div.withConfig({
  displayName: "switch-with-label__SwitchWithLabelCmp",
  componentId: "sc-1azuep3-0"
})(["display:inline-flex;align-items:center;margin:0 15px;label{font-size:0.85rem;margin-left:", ";}"], sizes.tiny);
export function SwitchWithLabel({
  id,
  label,
  checked,
  ...rest
}) {
  return /*#__PURE__*/React.createElement(SwitchWithLabelCmp, null, /*#__PURE__*/React.createElement(Switch, _extends({
    id: id
  }, rest, {
    checked: !!checked
  })), /*#__PURE__*/React.createElement("label", {
    htmlFor: id
  }, label));
}
SwitchWithLabel.defaultProps = {
  checked: false
};
SwitchWithLabel.propTypes = {
  checked: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func
};